import React, { useEffect, useState } from "react";
import CustomTabs from "../../components/ui/CustomTabs";
import { useParams, useNavigate } from "react-router-dom";
import GuildLands from "../../components/guildComponents/landsComponent";
import ShardSales from "../../components/guildComponents/shardsComponent";
import GuildMembers from "../../components/guildComponents/userComponent";
const verified = "https://pixelore.s3.eu-central-003.backblazeb2.com/Random+Images/verified.png";
const suspicious = "https://pixelore.s3.eu-central-003.backblazeb2.com/Random+Images/suspicious.png";

function GuildDetail() {
  const { handle, tab } = useParams();
  const navigate = useNavigate();
  const [guildData, setGuild] = useState(null);
  const [guildMembers, setGuildMembers] = useState([]);
  const [guildLands, setGuildLands] = useState([]);
  const [guildShards, setGuildShards] = useState([]);
  const [guildDiscord, setGuildDiscord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(tab || "users");

  const extractDiscordLinks = (description) => {
    if (!description) return null;
    const discordRegex = /(?:https?:\/\/)?(?:www\.)?(?:discord\.(?:gg|com\/invite)|discordapp\.com\/invite)\/([a-zA-Z0-9-]+)/gi;
    const matches = description.match(discordRegex);
    return matches ? matches[0] : null;
  };

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    }
  }, [tab]);

  useEffect(() => {
    setLoading(true);
    fetch(`https://api.pixelore.wiki/api/guilds/${handle}`)
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        setGuild(data);
        setGuildMembers(data.guildMembers || []);
        setGuildLands(data.maps?.lands || []);
        setGuildShards(data.shardResults || []);
        setGuildDiscord(extractDiscordLinks(data.guild?.description));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching guild:", error);
        setError(error.message);
        setLoading(false);
      });
  }, [handle]);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    navigate(`/lookup/guilds/${handle}/${tabKey}`);
  };

  const guildTabs = [
    { key: "users", label: "Guild Members", component: <GuildMembers users={guildMembers} /> },
    { key: "lands", label: "Guild Lands", component: <GuildLands lands={guildLands} /> },
    { key: "shards", label: "Shard Sales", component: <ShardSales shards={guildShards} /> },
  ];

  return (
    <div className="panel-style md:max-w-6xl">
      {loading ? (
        <div className="p-8 text-center">Loading...</div>
      ) : error ? (
        <div className="p-8 text-center text-red-500">{error}</div>
      ) : guildData ? (
        <div className="mb-2">
          {/* Suspicious Guild Icon */}
          {guildData.guild?.suspicious && <img src={suspicious} alt="Suspicious" className="absolute h-10 w-10 top-0 right-[5px]" />}

          {/* Official Guild Icon */}
          {guildData.guild?.official && <img src={verified} alt="Verified" className="absolute h-10 w-10 top-0 right-[5px]" />}

          <h2 className="panel-heading">{guildData.guild?.name || handle} Details</h2>

          <div className="flex flex-col sm:flex-row gap-4 items-start">
            {guildData.guild?.emblem && (
              <img src={`https://${guildData.guild?.emblem.replace(/^\/\//, "")}`} alt={guildData.guild?.name} className="rounded h-24 w-24 border" />
            )}
            <div className="flex-1">
              <div className="flex gap-2 mb-1">
                {guildData.guild?.twitter && (
                  <a href={`https://x.com/${guildData.guild?.twitter}`} target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-square-twitter" style={{ color: "#74C0FC" }} />
                  </a>
                )}
                {guildDiscord && (
                  <a href={guildDiscord.startsWith("http") ? guildDiscord : `https://${guildDiscord}`} target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-discord" style={{ color: "#B197FC" }} />
                  </a>
                )}
              </div>
              <div className="space-x-1 text-xs">
                <span className="tags">
                  <i className="fa-solid fa-mountain-sun mr-1 text-xs" /> {guildData.guild?.mapCount || 0}{" "}
                </span>
                <span className="tags">
                  <i className="fa-solid fa-user mr-1 text-xs" />
                  {guildData.guild?.maxMembers || 0}
                </span>
                <span className="tags">
                  <i className="fa-solid fa-gem mr-1 text-xs" />
                  {guildData.buyFee}
                </span>
                {guildData.guild?.useWhitelist && (
                  <span className="tags">
                    <i className="fa-solid fa-w text-xs" />
                  </span>
                )}
              </div>
              <div className="bg-[var(--entity-mini)] text-xs rounded border text-[var(--text-color)] rounded-md p-2 my-2">
                {guildData.guild?.feeAddress && (
                  <p>
                    <strong>Treasury Address:</strong>{" "}
                    <a href={`https://app.roninchain.com/address/${guildData.guild.feeAddress}`} target="blank" rel="noreferrer" className="panel-link">
                      <span>{guildData.guild.feeAddress}</span>
                    </a>
                  </p>
                )}
                <p>
                  <strong>Treasury Balance:</strong> ${guildData?.treasuryResults?.toLocaleString() || 0} USD
                </p>
                {guildData.guild?.tokenId && (
                  <p>
                    <strong>Token ID:</strong>{" "}
                    <a
                      href={`https://app.roninchain.com/token/0x7ac8de4b2d37ac6136be285ee7060e8676c9644f/${guildData.guild.tokenId}`}
                      target="blank"
                      rel="noreferrer"
                      className="panel-link"
                    >
                      <span className="bg-[var(--level-bars-bg)] text-[var(--text-color)]">{guildData.guild.tokenId}</span>
                    </a>
                  </p>
                )}
              </div>
              <div className="bg-[var(--entity-mini)] text-xs rounded border text-[var(--text-color)] rounded-md p-2 my-1">
                <span className="text-[var(--text3-color)] text-sm font-semibold">Guild Description:</span> {guildData.guild?.description || "No description available"}
              </div>
            </div>
          </div>
          <hr/>
          <div className="mt-2">
          <CustomTabs tabs={guildTabs} activeTab={activeTab} onTabChange={handleTabChange} maxHeight={true}/></div>
        </div>
      ) : (
        <div className="p-8 text-center">No guild data found</div>
      )}
    </div>
  );
}

export default GuildDetail;
